import Coordinate from "./Coordinate";
import { ResizableImageItem } from "./ResizableImage";

enum OfficeExternalLinkType {
    None,
    Facebook,
    YouTube,
    Twitter,
    GoogleMyBusiness,
    LinkedIn,
    Pinterest,
    Instagram
}

interface OfficeExternalLink {
    Url: string;
    Type: OfficeExternalLinkType;
}

interface Office {
    Id: string;

    OfficeName: string;
    FranchiseName: string;

    Phone: string;
    Email: string;
    Fax: string;

    WebsitePhotoMain: ResizableImageItem;
    WebsitePhotoPreview: ResizableImageItem;

    CompanyName: string;
    About: string;
    ABN: string;

    DisplayAddress: boolean;
    AddressLine1: string;
    AddressLine2: string;

    Coordinate: Coordinate;

    VideoURL: string;

    OfficeSlug: string;
    FranchiseSlug: string;
    FullSlug: string;
    
    ExternalLinks: OfficeExternalLink[];
}

export { Office, OfficeExternalLink, OfficeExternalLinkType }